import { connect } from "react-redux";
import ChatFlowsComponent from "../../Components/ChatFlows/ChatFlowsComponent";
import { setChatFlows, setWhatsAppFlows } from "../../Redux/Actions/ChatFlowActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  st_ChatFlows: state.reducer.chatFlows,
  st_WhatsAppFlows: state.reducer.whatsAppFlows,
  CALL_FLOWS: state.reducer.CALL_FLOWS,
  SCOPES: state.reducer.SCOPES_NAMES,
});

const mapDispatchToProps = (dispatch) => ({
  setChatFlows: (chatFlows) => dispatch(setChatFlows(chatFlows)),
  setWhatsAppFlows: (whatsAppFlows) => dispatch(setWhatsAppFlows(whatsAppFlows)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatFlowsComponent);
